<template>
  <div><iframe class="iframe" src="https://tool.rockstime.com/"></iframe></div>
</template>

<script>
export default {
  name: 'toolName',
};
</script>

<style scoped>
.iframe {
  width: 100%;
  height: 100vh;
}
</style>
